
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { myCourseMenuFilter } from '@xt/client/dataSource/my/index'
import MyLayout from '../views/MyLayout/index.vue'
import { Observer } from 'mobx-vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import CourseCard from './views/CourseCard/index.vue'

@Observer
@Component({
  components: {
    MyLayout,
    EmptyStatus,
    CourseCard
  },
  async asyncData(ctx) {
    // 格式化合并路由参数
    const filterForm = ctx.store.$myV2.Course.parserQuery(ctx.query)
    // 初始化数据
    await ctx.store.$myV2.Course.loadMyProductList(filterForm)

    return {
      filterForm
    }
  }
})
export default class CoursePage extends Vue {
  filterForm: {
    // 课程分类
    courseType: string
    // 菜单分类
    contentType: string
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  // 内容区筛选项变化
  get filterLabels() {
    return myCourseMenuFilter.find(item => item.value === this.filterForm.contentType)?.filters || []
  }

  get MyStore() {
    return this.$store.$myV2.Course
  }

  get myCourseMenu() {
    return myCourseMenuFilter
  }

  // 更新筛选条件
  updateFilterForm(
    item: Partial<{
      courseType: string
      contentType: string
    }>
  ) {
    this.filterForm = {
      ...this.filterForm,
      ...item
    }

    const seachForm = this.MyStore.toSearchQuery(this.filterForm)

    this.$router.replace({
      query: {
        ...seachForm
      }
    })

    document.documentElement.scrollTo({ top: 0 })
  }

  // 点击内容区筛选项
  handleFilterChange(key: string) {
    if (this.filterForm.courseType === key) return

    this.updateFilterForm({
      courseType: key
    })

    this.MyStore.changeFilterList(this.filterForm)
  }

  // 点击左侧菜单项
  handleMenuChange(key: string) {
    if (this.filterForm.contentType === key) return

    this.updateFilterForm({
      contentType: key,
      courseType: ''
    })
    this.MyStore.changeFilterList(this.filterForm)
  }

  created(): void {
    this.MyStore.changeFilterList(this.filterForm)
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
